import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { StudenthomeworkComponent } from './studenthomework/studenthomework.component';
import { StudentTerminalReportComponent } from './student-terminal-report/student-terminal-report.component';
import { StudentAttendanceDetailsComponent } from './student-attendance-details/student-attendance-details.component';
import { StudentProfileComponent } from './student-profile/student-profile.component';
import { StudentFeeDetailComponent } from './student-fee-detail/student-fee-detail.component';
import { StudentFeePaymentComponent } from './student-fee-payment/student-fee-payment.component';
import { StudentAcademicsComponent } from './student-academics/student-academics.component';

import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { StudentFeeChallanComponent } from './student-fee-challan/student-fee-challan.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'studenthomework', component: StudenthomeworkComponent, pathMatch: 'full' },
      { path: 'studentfeedetail', component: StudentFeeDetailComponent, pathMatch: 'full' },
      { path: 'studentprofile', component: StudentProfileComponent, pathMatch: 'full' },
      { path: 'studentattendancedetails', component: StudentAttendanceDetailsComponent, pathMatch: 'full' },
      { path: 'studentterminalreport', component: StudentTerminalReportComponent, pathMatch: 'full' },
      { path: 'studentfeepayment', component: StudentFeePaymentComponent, pathMatch: 'full' },
      { path: 'studentacademics', component: StudentAcademicsComponent, pathMatch: 'full' },
      { path: 'student-fee-challan', component: StudentFeeChallanComponent, pathMatch: 'full' },
      { path: 'paymentsuccess', component: PaymentSuccessComponent, pathMatch: 'full' },

    ]
  },
  {
    path: '',
    
    children: [
      // { path: 'printstudentprofile', component: PrintStudentProfileComponent, pathMatch: 'full' },
     
     ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentportalRoutingModule { }
